export const ON_BREAK = 'ON_BREAK';
